import { Link, Paper, styled, Typography } from '@mui/material';
import React, { memo } from 'react';
import { useLayoutContext } from './useLayoutContext';
import { useWhiteLabelling } from 'hooks/useWhiteLabelling';

const AppFooter: React.FC = () => {
  const { printMode } = useLayoutContext();
  const whiteLabelling = useWhiteLabelling();

  if (printMode) return null;

  return (
    <StyledPaperRoot>
      <Typography variant="h4" color="white" fontWeight="800" pb={2}>Questions? Reach out to us!</Typography>
      <Typography variant="body1" color="white">
        Email us at <Link
        href={`mailto:${whiteLabelling.email}`}
        color="inherit"
        fontWeight="bold"
        underline="none"
      >{whiteLabelling.email}</Link>
      </Typography>
      <Typography variant="body1" color="white">
        or call us at <Link
        href={whiteLabelling.phoneNumberLink}
        color="inherit"
        fontWeight="bold"
        underline="none"
      >{whiteLabelling.formattedPhoneNumber}</Link>
      </Typography>
    </StyledPaperRoot>
  );
};

const StyledPaperRoot = styled(Paper)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.mode === 'light' ? theme.palette.primary.main : 'background.paper',
  borderRadius: 0,
}));

export default memo(AppFooter);
